import { ROLES } from './ROLES';

export const ROLES_GROUPS = {
    SD_GROUP: [ROLES.ADMINISTRATOR, ROLES.OPERATIVO, ROLES.PROVEEDOR_SD],
    MKT_GROUP: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
    CLIENT_GROUP: [ROLES.COMPRAS, ROLES.COMPRAS_SR, ROLES.CALIDAD, ROLES.RH],
    PROVIDER_GROUP: [ROLES.PROVEEDOR, ROLES.PROVEEDOR_SD],
    ORDER_GROUP: [
        ROLES.ADMINISTRATOR,
        ROLES.OPERATIVO,
        ROLES.PROVEEDOR_SD,
        ROLES.PROVEEDOR,
        ROLES.LOGISTIC,
        ROLES.COMPRAS_SR,
        ROLES.COMPRAS,
        ROLES.CALIDAD
    ]
};
